import HeroImage from '../../Icons/faq/Image.svg'
import HeroDescription from '../Headings/HeroDescription'
import HeroHeading from '../Headings/HeroHeading'

export default function HeroBanner() {
    return (
        <div className="max-w-5xl w-full mx-auto my-16 px-4">
            <div className="flex flex-col md:flex-row items-center md:space-x-4 space-y-5 md:space-y-0">
                <div className="w-full md:w-7/12 text-left space-y-8">
                    <HeroHeading>
                        <span className="olm-gradient-text">
                            FAQs – Your <br />
                            Questions Answered
                        </span>
                        <br />
                    </HeroHeading>
                    <HeroDescription>
                        Explore our frequently asked questions on everything
                        from lists and direct mail best practices to ordering
                        and tracking.
                    </HeroDescription>
                </div>
                <div className="w-full md:w-5/12">
                    <div className="h-full flex justify-center md:block">
                        <HeroImage className="max-w-full" />
                    </div>
                </div>
            </div>
        </div>
    )
}
